"use client";

import Image from "next/image";
import { usePathname, useRouter, useSearchParams } from "next/navigation";
import { useCallback, useEffect } from "react";
import ModelFinderOptions, {
	ModelFinderOption,
} from "../../../../components/model-finder-options";
import ModelFinderProgress from "../../../../components/model-finder-progress";
import { AnalyticEventNames } from "../../../../utilities/env";
import { analytics } from "../../../../utilities/segment";
import { ModelFinderNavBar } from "../navbar";

type Data = {
	data: ModelFinderOption[];
	zipCode: string;
	size: string;
};

export function FindSizeClient({ size, zipCode, data }: Data) {
	const router = useRouter();
	const pathname = usePathname();
	const searchParams = useSearchParams();
	const createQueryString = useCallback(
		(name: string, value: string) => {
			const params = new URLSearchParams(searchParams?.toString());
			params.set(name, value);
			return params.toString();
		},
		[searchParams],
	);
	useEffect(() => {
		if (size === "") {
			analytics?.track(AnalyticEventNames.modelFinderStarted);
		}
	}, [size]);
	return (
		<>
			<div className="wrapper-lg flex w-full flex-grow flex-col justify-center py-10 text-center">
				<ModelFinderProgress step="size" />
				<h1 className="text-headline-3 mt-6 text-primary-800">
					What size home are you envisioning for your lifestyle?
				</h1>
				<ModelFinderOptions
					options={data}
					selected={[size]}
					setSelected={(size: string) =>
						router.replace(`${pathname}?${createQueryString("size", size)}`, {
							scroll: false,
						})
					}
					imageElement={(image, alt) => (
						<Image src={image} alt={alt} width={146} height={85} />
					)}
					optionClasses="flex-col justify-center max-w-96"
				/>
			</div>
			<ModelFinderNavBar
				nextLink={`/find/beds?zipCode=${zipCode}&size=${size}`}
				nextDisabled={size === ""}
				analyticsSelections={{ size }}
			/>
		</>
	);
}
